import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PreviewModeContext = createContext();

export const usePreviewMode = () => {
    return useContext(PreviewModeContext);
};

export const PreviewModeProvider = ({ children }) => {
    const [showSidebar, setShowSidebar] = useState(true);
    const [showNavbar, setShowNavbar] = useState(true);
    const location = useLocation();
    
    // add the only routes which are directly showing the preview mode
    // and not the routes which are showing the preview mode after clicking on any button or the preview button
    // for example: /experience/bulk-preview and /experience/edit-experience
    // are the routes which are directly showing the preview mode
    const hiddenRoutes = [
        "/experience/bulk-preview",
        "/experience/edit-experience",
        "/experience/edit-template",
        "/experience/create-template",
        "/experience/templates-preview"
    ];

    useEffect(() => {
        const shouldHide = hiddenRoutes.some((route) =>
            location.pathname.includes(route)
        );
        setShowSidebar(!shouldHide);
        setShowNavbar(!shouldHide);
    }, [location.pathname]);

    const enablePreviewMode = () => {
        setShowSidebar(false);
        setShowNavbar(false);
    };

    const disablePreviewMode = () => {
        setShowSidebar(true);
        setShowNavbar(true);
    };

    const value = {
        showSidebar,
        showNavbar,
        enablePreviewMode,
        disablePreviewMode,
    };

    return (
        <PreviewModeContext.Provider value={value}>
            {children}
        </PreviewModeContext.Provider>
    );
};
